import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHZonaDel = async (credentials, data) => {
    const body = {
        service: "RNHZonaDel",
        params: {
            rnhZonaId: data?.id || null,
            rnhZonaVersion: data?.version ?? null,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
